import { ActivityJson } from 'app/types/entities'
import { ContactJson } from 'app/types/entities'

export function getChannelColorMap(channel: ContactJson[`channel`]) {
  switch (channel) {
    case `Digital Marketing`:
      return `#3385ff`
    case `Referral Marketing`:
      return `#a049ff`
    case `Traditional Marketing`:
      return `#1ab9d9`
    case `Unknown`:
      return `#E5E5E5`
    case `Organic Search`:
      return `#10B981`
    case `Paid Search`:
      return `#3B82F6`
    case `Organic Social`:
      return `#9333EA`
    case `Paid Social`:
      return `#60A5FA`
    case `Email`:
      return `#F87171`
    case `Referral`:
      return `#FDBA74`
    case `Display`:
      return `#5EEAD4`
    case `Paid Video`:
      return `#FCD34D`
    case `Direct`:
      return `#737373`
    case `Offline`:
      return `#525252`
    case `Print`:
      return `var(--chart-navy)`
    default:
      return `#ffffff00`
  }
}

export function getLeadStatusColorMap(leadStatus: ContactJson[`leadStatus`]) {
  switch (leadStatus) {
    case `Needs Action`:
      return `#fdba74`
    case `Closed Won`:
      return `#3b82f6`
    case `In Progress`:
      return `#10B981`
    case `Closed Lost`:
      return `#F87171`
    case `Scheduled`:
      return `#22D3EE`
    default:
      return `#ffffff00`
  }
}

export function getActivityTypeColorMap(activityType: ActivityJson[`type`]) {
  switch (activityType) {
    case `Call`:
      return `#3b82f6`
    case undefined:
    case `Unknown`:
      return `#d3d3d3`
    case `Chat`:
      return `#10b981`
    case `Form`:
      return `#fdba74`
    case `Online Scheduler`:
      return `#22d3ee`
    default:
      return `#ffffff00`
  }
}
